import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getClassrooms } from "../../redux/actions/classroomActions";
import AppSelectFilter from "./AppSelectFilter";

interface Props {
  value: string;
  onChange: (classroomId: string) => void;
  branchId?: string;
  label?: string;
  allLabel?: string;
  minWidth?: number | string;
}

export const ClassroomSelectFilter: React.FC<Props> = ({
  value,
  onChange,
  branchId,
  label = "Classroom",
  allLabel = "All Classes",
  minWidth = 140,
}) => {
  const dispatch = useAppDispatch();
  const {
    items: classrooms,
    loadingFetchAll: loading,
    errorFetchAll: error,
  } = useAppSelector((state) => state.classroom);
  const attempted = useRef(false);

  useEffect(() => {
    if (!classrooms.length && !loading && !error && !attempted.current) {
      attempted.current = true;
      dispatch(getClassrooms(branchId ? { branchId } : undefined));
    }
  }, [dispatch, classrooms.length, loading, error, branchId]);

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={classrooms.map((c) => ({ value: c.id, label: c.name }))}
      allLabel={allLabel}
      minWidth={minWidth}
    />
  );
};
export default ClassroomSelectFilter;
